import { gql } from "@apollo/client";
import { HubOption, WhsOption } from "../types/ConsolidationTypes";

export const GET_HUB_AND_WHS_OPTIONS = gql`
    query GetHubAndWhsOptions($hubName: String, $whsName: String) {
        getHubAndWhsOptions(hubName: $hubName, whsName: $whsName) {
            hubOptions {
                hubId
                hubName
                sortingCode
            }
            whsOptions {
                whsId
                whsName
                parentHubId
                sortingCode
            }
        }
    }
`;

export interface GetHubAndWhsOptionsVariables {
    hubName?: string;
    whsName?: string;
}

export interface GetHubAndWhsOptionsResponse {
    getHubAndWhsOptions: {
        hubOptions: HubOption[];
        whsOptions: WhsOption[];
    };
} 